module.exports = __webpack_public_path__ + "img/s-icon-niesen-fork.0000caf4.svg";